import type { Job } from '@mairistem/composants';
import { request } from '@mairistem/tools';

export const getUtilisateurs = (
	codeClient: string,
	codePostal: string,
	codeAccess: string,
) =>
	request.get<unknown, Job>('/api/ixchange/pastell/structureJob', {
		'X-CodeClient': codeClient,
		codeAccess,
		codePostal,
	});

export const getStructureJobWithBearer = (token: string, codeClient: string) =>
	request.get<unknown, Job>('/api/ixchange/pastell/structureJob', {
		headers: {
			Authorization: `Bearer ${token}`,
			'X-CodeClient': codeClient,
		},
	});

export default getUtilisateurs;
